function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { withMedia } from 'react-media-query-hoc';
import AllhomesMap from '@domain-group/fe-co-allhomes-map';
import { useSendEvent } from '@domain-group/fe-co-allhomes-analytics';
import FooterCard from './footer-card';
import AllhomesAgentModel from './agent-model';
import * as styles from './agent-footer.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var AllhomesAgentFooter = props => {
  var _useSendEvent = useSendEvent(),
    sendEvent = _useSendEvent.sendEvent;
  var _useState = useState(props.profile.address.zoomLevel),
    _useState2 = _slicedToArray(_useState, 2),
    zoomLevel = _useState2[0],
    setZoomLevel = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    mapInteractionEventEmitted = _useState4[0],
    setMapInteractionEventEmitted = _useState4[1];
  var _useState5 = useState({
      lat: props.profile.address.lat,
      lng: props.profile.address.lng
    }),
    _useState6 = _slicedToArray(_useState5, 2),
    coords = _useState6[0],
    setCoords = _useState6[1];
  useEffect(() => {
    var request = _objectSpread({}, props.profile.address);
    var geocoderQueryUrl = "".concat(props.geocoderEndpoint, "?").concat(new URLSearchParams(request));
    fetch(geocoderQueryUrl).then(response => {
      if (response.ok) {
        return response.json();
      }
      return false;
    }).then(data => {
      setZoomLevel(data.zoomLevel);
      setCoords({
        lat: data.lat,
        lng: data.lng
      });
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  var mobile = props.media.mobile;
  var mapEvent = () => {
    if (!mapInteractionEventEmitted) {
      sendEvent('map-interacted');
    }
    setMapInteractionEventEmitted(true);
  };
  return ___EmotionJSX("div", {
    css: styles.footer
  }, ___EmotionJSX("div", {
    css: styles.map
  }, props.googleMapsParams && ___EmotionJSX(AllhomesMap, {
    coords: coords,
    zoom: zoomLevel,
    googleMapsParams: props.googleMapsParams,
    onMarkerClicked: mapEvent,
    onMapClick: mapEvent,
    onDragEnd: mapEvent,
    onRightClick: mapEvent
  })), !mobile && ___EmotionJSX(FooterCard, _extends({}, props.profile, {
    onEmailClick: props.onEmailClick
  })));
};
AllhomesAgentFooter.propTypes = {
  profile: PropTypes.shape(AllhomesAgentModel).isRequired,
  googleMapsParams: PropTypes.shape({
    key: PropTypes.string.isRequired
  }).isRequired,
  onEmailClick: PropTypes.func.isRequired,
  geocoderEndpoint: PropTypes.string.isRequired,
  media: PropTypes.shape({
    mobile: PropTypes.bool
  })
};
AllhomesAgentFooter.defaultProps = {
  media: {}
};
export default withMedia(AllhomesAgentFooter);